export const calculateElapsedTime = (startDate: Date, endDate: Date) => {
    return endDate.valueOf() - startDate.valueOf();
}